import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PreVideo.css'; // Make sure to create this CSS file for styling

const PreVideo = () => {
    return (
        <div className="container-adds-or-clips">
            <Link to="/adds-video" className="link">
                <span className="video-text">video</span>
                <span className="adds-text">ADS</span>
            </Link>
            <Link to="/video" className="link">
                <span className="video-text">video</span>
                <span className="clips-text">CLIPS</span>
            </Link>
        </div>
    );
};

export default PreVideo;
